const axios = require('axios');

const axiosInstance = axios.create({
    // baseURL: 'http://localhost:8000'
    baseURL: 'https://api20.pythonanywhere.com'
    /* other custom settings */
});

module.exports = axiosInstance;